import React, { useState, useEffect } from "react";
import * as firebase from "firebase";
import { Layout, Row, Col, Card, message, Modal } from "antd";
import { v4 as uuidv4 } from "uuid";
import {
  EditorState,
  convertToRaw,
  ContentState,
  convertFromHTML,
} from "draft-js";
import { storage } from "firebase";
import draftToHtml from "draftjs-to-html";
import htmlToDraft from "html-to-draftjs";
import { isEmpty, map } from "lodash";
import { Redirect } from "react-router-dom";

import {
  addLatestArticle,
  getLatestArticles,
  deleteLatestArticle,
  deleteFileFromStorage,
  updateLatestArticleFields,
  updateLatestArticleFieldsWithImage,
} from "../Database/firebase";
import Header from "../Components/Header";
import LatestArticleForm from "../Components/LatestArticleForm";
import LatestArticleTable from "../Components/LatestArticleTable";

const { Content } = Layout;

const AddLatestArticlePage = () => {
  const [loggedIn, setLoggedIn] = useState();
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(false);
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [descriptionEditor, setDescriptionEditor] = useState(
    EditorState.createWithContent(
      ContentState.createFromBlockArray(convertFromHTML(``))
    )
  );
  const [affiliateLink, setAffiliateLink] = useState("");
  const [applyedFilters, setApplyedFilters] = useState(["latest"]);
  const [tags, setTags] = useState("");
  const [date, setDate] = useState(null);
  const [zone, setZone] = useState("America/New_York");
  const [imageAsFile, setImageAsFile] = useState(null);
  const [imageUrl, setImageUrl] = useState("");
  const [latestArticleList, setLatestArticleList] = useState([]);
  const [editMode, setEditMode] = useState(false);
  const [selectedCard, setSelectedCard] = useState(null);
  const [imagePath, setImagePath] = useState(null);
  const [imageName, setImageName] = useState("");
  const [isConfirmationModalOpen, setConfirmationModalOpen] = useState(false);
  // const [
  //   articleCollectionBeforeUploading,
  //   setArticleCollectionBeforeUploading,
  // ] = useState([]);
  const [
    imageValidationModalVisible,
    setImageValidationModalVisible,
  ] = useState(false);

  useEffect(() => {
    const tempArry = [];
    setLoading(true);

    getLatestArticles.then((snapshot) => {
      setLoading(false);
      if (!isEmpty(snapshot)) {
        snapshot.forEach((doc) => {
          tempArry.push({ ...{ id: doc.id }, ...doc.data() });
        });
        setLatestArticleList(tempArry);
      }
    });

    // Get User from localstorage
    let user = localStorage.getItem("User");
    if (user) {
      setLoggedIn(true);
      setUser(JSON.parse(user));
    } else {
      setLoggedIn(false);
    }

    localStorage.setItem("descriptionImagesUrl", JSON.stringify([]));
  }, []);

  const cancelEditMode = () => {
    setEditMode(false);
    setSelectedCard(null);
    resetFields();
  };

  const logout = () => {
    firebase
      .auth()
      .signOut()
      .then(function () {
        // Sign-out successful.
        localStorage.clear();
        setLoggedIn(false);
      })
      .catch(function (error) {
        // An error happened.
        console.error(error);
      });
  };

  const onChange = (value, key) => {
    switch (key) {
      case "title":
        setTitle(value);
        break;
      case "description":
        setDescription(value);
        break;
      case "description_editor":
        setDescriptionEditor(value);
        // console.log("descEditor>>>>>", value)
        break;
      case "affiliate":
        setAffiliateLink(value);
        break;
      case "applyedFilters":
        // console.log("applyedFilters Values>>>", value)
        setApplyedFilters(value);
        break;
      case "tags":
        setTags(value.split(","));
        break;
      case "date":
        setDate(value);
        break;
      case "zone":
        setZone(value);
        break;
      default:
        break;
    }
  };

  const onFileUpload = (e) => {
    console.log(e.file);
    setImageAsFile(e.file);
    if (Array.isArray(e)) {
      return e;
    }
    return e && e.fileList;
  };

  const resetFields = () => {
    setTitle("");
    // setDescrliption("");
    setDescriptionEditor("");
    setTags("");
    setDate(null);
    setImageAsFile(null);
    setAffiliateLink("");
    setImageUrl("");
    setZone("America/New_York");
    setImagePath("");
    setDescription("");
  };

  const addNewArticle = (imageName) => {
    const newArticle = {
      title: title,
      description: description,
      description_editor: draftToHtml(
        convertToRaw(descriptionEditor.getCurrentContent())
      ),
      tags: tags,
      date: date,
      zone: zone,
      applyedFilters: applyedFilters,
      imagePath: `/article_images/${imageName}`,
      imageUrl: imageUrl ? imageUrl : localStorage.getItem("uploadedImageUrl"),
      affiliateLink: affiliateLink,
      createdAt: new Date(),
      authorIs: "",
      // descriptionImages: JSON.parse(
      //   localStorage.getItem("descriptionImagesUrl")
      // ),
    };

    addLatestArticle(newArticle)
      .then((doc) => {
        // reset urls
        // localStorage.setItem("uploadedImageUrl", "");
        // localStorage.setItem("uploadedVideoUrl", "");
        const temp = [...latestArticleList];
        newArticle.id = doc.id;
        temp.push(newArticle);
        setLatestArticleList(temp);
        setLoading(false);
        resetFields();
        // resetDescriptionImagesFromLocalStorage();
        message.info("Article Added!");
      })
      .catch((error) => {
        console.error(error);
      });
  };

  const onSubmit = () => {
    const imageName = uuidv4();
    if (isEmpty(imageAsFile)) {
      setImageValidationModalVisible(true);
      return console.error(
        `not an image, the image file is a ${typeof imageAsFile}`
      );
    }
    setLoading(true);
    imageUpload(imageName);
  };

  const getChildByRefName = (childName, refName) => {
    return new Promise((resolutionFunc, rejectionFunc) => {
      storage()
        .ref(refName)
        .child(childName)
        .getDownloadURL()
        .then((fireBaseUrl) => {
          console.log(`================== fireBaseUrl ${refName}`, fireBaseUrl);
          setImageUrl(fireBaseUrl);
          localStorage.setItem("uploadedImageUrl", fireBaseUrl);
          setImageAsFile(null);
          resolutionFunc(true);
        })
        .catch((err) => {
          console.log("ERR getDownloadURL", err.message);
        });
    });
  };

  const imageUpload = (imageName) => {
    return new Promise((resolutionFunc, rejectionFunc) => {
      const uploadTask = storage()
        .ref(`/latest_article_images/${imageName}`)
        .put(imageAsFile.originFileObj);
      uploadTask.on(
        "state_changed",
        (snapShot) => {
          console.log(snapShot);
        },
        (err) => {
          console.log("ERR uploadTask", err);
        },
        () => {
          getChildByRefName(imageName, "latest_article_images").then(() => {
            addNewArticle(imageName);
            resolutionFunc(true);
          });
        }
      );
    });
  };

  const updateArticleWithoutImages = (updatedTags) => {
    // updateDescriptionImages().then(() => {
    const article = {
      title,
      description,
      description_editor: draftToHtml(
        convertToRaw(descriptionEditor.getCurrentContent())
      ),
      applyedFilters: applyedFilters,
      tags: updatedTags,
      date,
      zone,
      affiliateLink: affiliateLink,
      authorIs: "",
      // descriptionImages: JSON.parse(
      //   localStorage.getItem("descriptionImagesUrl")
      // ),
    };
    updateLatestArticleFields(selectedCard.id, article)
      .then(() => {
        const temp = [...latestArticleList];
        const index = temp.findIndex((el) => el.id === selectedCard.id);
        temp[index].title = title;
        temp[index].description = description;
        temp[index].description_editor = draftToHtml(
          convertToRaw(descriptionEditor.getCurrentContent())
        );
        temp[index].tags = updatedTags;
        temp[index].applyedFilters = applyedFilters;
        temp[index].date = date;
        temp[index].affiliateLink = affiliateLink;
        temp[index].authorIs = "";
        // temp[index].descriptionImages = JSON.parse(
        //   localStorage.getItem("descriptionImagesUrl")
        // );
        setLatestArticleList(temp);
        setLoading(false);
        setImageAsFile(null);
        setEditMode(false);
        message.info("Article Updated!");
        resetFields();
        // resetDescriptionImagesFromLocalStorage();
      })
      .catch((err) => {
        console.log("ERR updateDeckName", err.message);
      });
    // });
  };

  const updateArticleWithImage = (refName, updatedTags, fireBaseUrl) => {
    // updateDescriptionImages().then(() => {
    const article = {
      title,
      description,
      description_editor: draftToHtml(
        convertToRaw(descriptionEditor.getCurrentContent())
      ),
      tags: updatedTags,
      applyedFilters: applyedFilters,
      date,
      imageUrl: fireBaseUrl,
      zone,
      imagePath: `/latest_article_images/${refName}`,
      affiliateLink: affiliateLink,
      authorIs: "",
      // descriptionImages: JSON.parse(
      //   localStorage.getItem("descriptionImagesUrl")
      // ),
    };

    updateLatestArticleFieldsWithImage(selectedCard.id, article).then(() => {
      const temp = [...latestArticleList];
      const index = temp.findIndex((el) => el.id === selectedCard.id);
      temp[index].title = title;
      temp[index].description = description;
      temp[index].description_editor = draftToHtml(
        convertToRaw(descriptionEditor.getCurrentContent())
      );
      temp[index].tags = updatedTags;
      temp[index].applyedFilters = applyedFilters;
      temp[index].date = date;
      temp[index].imageUrl = fireBaseUrl;
      temp[index].imagePath = `/latest_article_images/${imageName}`;
      temp[index].affiliateLink = affiliateLink;
      temp[index].authorIs = "";
      // temp[index].descriptionImages = JSON.parse(
      //   localStorage.getItem("descriptionImagesUrl")
      // );

      setLatestArticleList(temp);
      setLoading(false);
      message.info("Article Updated!");
      // resetDescriptionImagesFromLocalStorage();
    });
    // });
  };

  const uploadArticleImage = (refName, imageName, updatedTags, imageFile) => {
    // console.log("Deleted Old File");
    return new Promise((resolutionFunc, rejectionFunc) => {
      const uploadTask = storage()
        .ref(`/${imageName}/${refName}`)
        .put(imageFile.originFileObj);
      uploadTask.on(
        "state_changed",
        (snapShot) => {
          console.log(snapShot);
        },
        (err) => {
          console.log(err);
        },
        () => {
          storage()
            .ref(imageName)
            .child(refName)
            .getDownloadURL()
            .then(async (fireBaseUrl) => {
              setImageUrl(fireBaseUrl);
              setImagePath(`/latest_article_images/${imageName}`);
              setImageName(imageName);
              updateArticleWithImage(refName, updatedTags, fireBaseUrl);
              // localStorage.setItem("uploadedImageUrl", fireBaseUrl);
              // localStorage.setItem(
              //   "imagePath",
              //   `/article_images/${imageOrVideoName}`
              // );
              resolutionFunc(true);
            })
            .catch((err) => {
              console.log("ERR updateDeckNameImage", err.message);
            });
        }
      );
    });
  };

  const updateTaskArticle = (refName, imageName, updatedTags, imageFile) => {
    // updateDescriptionImages().then(() => {
    const uploadTask = storage()
      .ref(`/${refName}/${imageName}`)
      .put(imageFile.originFileObj);
    uploadTask.on(
      "state_changed",
      (snapShot) => {
        console.log(snapShot);
      },
      (err) => {
        console.log(err);
      },
      () => {
        storage()
          .ref(refName)
          .child(imageName)
          .getDownloadURL()
          .then((fireBaseUrl) => {
            const article = {
              title,
              description,
              description_editor: draftToHtml(
                convertToRaw(descriptionEditor.getCurrentContent())
              ),
              tags: updatedTags,
              applyedFilters: applyedFilters,
              date,
              zone: zone,
              imageUrl: fireBaseUrl,
              imagePath: `/${refName}/${imageName}`,
              affiliateLink: affiliateLink,
              authorIs: "",
              // descriptionImages: JSON.parse(
              //   localStorage.getItem("descriptionImagesUrl")
              // ),
            };

            updateLatestArticleFieldsWithImage(selectedCard.id, article).then(
              () => {
                const temp = [...latestArticleList];
                const index = temp.findIndex((el) => el.id === selectedCard.id);
                temp[index].title = title;
                temp[index].description = description;
                temp[index].description_editor = draftToHtml(
                  convertToRaw(descriptionEditor.getCurrentContent())
                );
                temp[index].tags = updatedTags;
                temp[index].applyedFilters = applyedFilters;
                temp[index].date = date;
                temp[index].imageUrl = fireBaseUrl;
                temp[index].imagePath = `/${refName}/${imageName}`;
                temp[index].affiliateLink = affiliateLink;
                temp[index].authorIs = "";
                // temp[index].descriptionImages = JSON.parse(
                //   localStorage.getItem("descriptionImagesUrl")
                // );

                setLatestArticleList(temp);
                setLoading(false);
                resetFields();
                // resetDescriptionImagesFromLocalStorage();
                message.info("Article Updated!");
              }
            );
          })
          .catch((err) => {
            console.log("ERR updateDeckNameImage", err.message);
          });
      }
    );
    // });
  };

  const deleteImagesFileFromStorage = (
    refName,
    file,
    imageName,
    updatedTags
  ) => {
    const path = selectedCard.imagePath;
    deleteFileFromStorage(path).then(() => {
      updateTaskArticle(refName, imageName, updatedTags, file);
    });
  };

  const updateArticle = (e) => {
    e.preventDefault();
    const imageName = uuidv4();

    let updatedTags = tags;
    if (typeof tags === "string") updatedTags = tags.split(",");

    setLoading(true);
    if (imageAsFile) {
      if (selectedCard.imageUrl) {
        deleteImagesFileFromStorage(
          "latest_article_images",
          imageAsFile,
          imageName,
          updatedTags
        );
      } else {
        uploadArticleImage(
          "latest_article_images",
          imageName,
          updatedTags,
          imageAsFile
        );
      }
    } else {
      updateArticleWithoutImages(updatedTags);
    }
  };

  const editArticle = (deck) => {
    const {
      title,
      description,
      tags,
      date,
      description_editor,
      applyedFilters,
      imageUrl,
      imagePath,
      affiliateLink,
      authorIs,
      zone,
    } = deck;

    let editorState;
    // console.log("description_editor object",description_editor)
    if (description_editor == undefined) {
      // console.log("description_editor true",description_editor)
      editorState = EditorState.createWithContent(
        ContentState.createFromBlockArray(convertFromHTML(description))
      );
    } else {
      // console.log("description_editor false",description_editor)
      const blocksFromHtml = htmlToDraft(description_editor);
      const { contentBlocks, entityMap } = blocksFromHtml;
      const contentState = ContentState.createFromBlockArray(
        contentBlocks,
        entityMap
      );
      editorState = EditorState.createWithContent(contentState);
    }
    // console.log("edit passed data",deck)
    setAffiliateLink(affiliateLink);
    setZone(zone);
    setSelectedCard(deck);
    setTitle(title);
    setDescription(description);
    setDescriptionEditor(editorState);
    setTags(tags.toString());
    setDate(date);
    setApplyedFilters(applyedFilters);
    setEditMode(true);
    setImageUrl(imageUrl);
    setImagePath(imagePath);
    // localStorage.setItem(
    //   "descriptionImagesUrl",
    //   JSON.stringify(descriptionImages)
    // );
  };

  const deleteAllArticles = () => {
    setConfirmationModalOpen(false);
    map(latestArticleList, (singleArticle, index) => {
      deleteLatestArticle(singleArticle.id).then(() => {
        if (latestArticleList.length === index + 1) setLatestArticleList([]);
      });
    });
  };

  if (loggedIn === null) return <div />;
  if (loggedIn === false) return <Redirect to={"/"} />;

  return (
    <div className="Addlatest-Article">
      <Layout className="layout" style={{ background: "#1f2228" }}>
        <Header logout={logout} componentName="LatestArticlePage" />
        <Content style={{ padding: "0 10px", background: "#1f2228" }}>
          <div className="site-layout-content">
            <Row>
              <Col span={24}>
                <Card style={{ borderRadius: "15px" }}>
                  <LatestArticleForm
                    id={editMode ? selectedCard.id : ""}
                    onChange={onChange}
                    title={title}
                    descriptionEditor={descriptionEditor}
                    affiliateLink={affiliateLink}
                    applyedFilters={applyedFilters}
                    tags={tags}
                    date={date}
                    zone={zone}
                    file={imageAsFile}
                    description_editor={descriptionEditor}
                    onFileUpload={onFileUpload}
                    onSubmit={editMode ? updateArticle : onSubmit}
                    loading={loading}
                    onCancelEditMode={cancelEditMode}
                    editMode={editMode}
                    articleCountes={latestArticleList.length}
                  />
                </Card>
              </Col>
            </Row>
            <Row>
              <Col flex={2}>
                <Card style={{ marginTop: 10, borderRadius: "15px" }}>
                  <LatestArticleTable
                    deleteAllArticle={() => setConfirmationModalOpen(true)}
                    articles={latestArticleList}
                    onEditClick={editArticle}
                    loading={loading}
                  />
                </Card>
              </Col>
            </Row>
          </div>
        </Content>
      </Layout>
      <Modal
        title="Please upload a image file for this operation."
        visible={imageValidationModalVisible}
        onOk={() => setImageValidationModalVisible(false)}
        onCancel={() => setImageValidationModalVisible(false)}
      />
      <Modal
        title="Are you sure to delete all articles ?"
        visible={isConfirmationModalOpen}
        onOk={deleteAllArticles}
        onCancel={() => setConfirmationModalOpen(false)}
      />
    </div>
  );
};

export default AddLatestArticlePage;
